<template>
    <list class="m-0 p-0" v-model="teams" :columns="columns" :pagination="pagination"
          :actions="actions"
          :loading="loading"
          :sort-change="sortChange"
          :edit="(props) => $router.push({ name: 'TeamEdit', params: { id: props.row.$id } })"
          :remove="(props) => confirmAndDelete(props.row)"
          search-enabled
          :search-query="query"
          @search-change="searchInput"
    />
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import TeamModel from 'src/store/models/Team'
  import List from '../../Components/BasicList'
  import debounce from 'lodash/debounce'

  export default {
    name: 'TeamList',
    components: { List },
    data () {
      return {
        sf: 'title',
        so: 'asc',
        query: '',
        loading: false,
        columns: [
          { name: 'title', text: 'Title', sortable: true, align: 'left' },
          { name: 'owner', text: 'Owner', formatter: this.userFormatter, sortable: true, align: 'left' }
        ],
        actions: [
          {label: 'Add Team', click: () => this.$router.push({ name: 'TeamCreate' })}
        ],
        debouncedChangeSearch: debounce(this.changeSearch.bind(this), 500)
      }
    },
    methods: {
      ...mapActions('pagination/team', ['paginate']),
      dateFormatter: function (row, column, cellValue) {
        return this.$options.filters.formatDate(cellValue)
      },
      userFormatter: function (row, column, cellValue) {
        return this.$options.filters.formatUser(cellValue)
      },
      fetchCurrentPage: async function () {
        try {
          const newPage = parseInt(this.$route.query.page, 10) || 1
          this.loading = true
          const result = await TeamModel.api().get('/team', {
            dataKey: 'items',
            params: { search: this.query, sf: this.sf, so: this.so, l: this.pagination.perPage, lo: newPage - 1 },
            save: false
          })
          if (result.response && result.response.data && result.response.data.total) {
            this.paginate({
              perPage: this.pagination.perPage,
              currentPage: newPage,
              total: result.response.data.total
            })
          }
          await TeamModel.create({data: result.response.data.items})
        } catch (e) { console.log('e', e)}
        finally {
          setTimeout(() => this.loading = false, 250)
        }
      },
      sortChange: function ({ column, prop, order }) {
        this.sf = prop || 'createdAt'
        this.so = (order || 'descending') === 'ascending' ? 'asc' : 'desc'
        this.fetchCurrentPage()
      },
      changePage (val) {
        const page = val > 1 ? val : undefined
        this.$router.push({ ...this.$router.currentRoute, query: { ...this.$route.query, page } })
      },
      changeSearch () {
        this.$router.push({ ...this.$router.currentRoute, query: { ...this.$route.query, q: this.query, page: 1  } })
      },
      searchInput (val) {
        this.query = val
        this.debouncedChangeSearch.cancel()
        this.debouncedChangeSearch()
      },
      confirmAndDelete: function (team) {
        this.$dialog.confirm(this.$t(`Confirm`), this.$t('Are you sure to delete {team}?', { team: team.title }), this.$t('Delete'))
          .then(async () => {
            await TeamModel.api().delete(`/team/${team._id}`)
            await this.fetchCurrentPage()
          })
      }
    },
    computed: {
      teams: () => TeamModel.all(),
      ...mapState('pagination', {
        pagination: (pagination) => pagination.team
      })
    },
    async mounted () {
      this.query = this.$route.query.q
      await this.fetchCurrentPage()
    },

    async beforeDestroy () {
      await TeamModel.deleteAll()
    },

    watch: {
      '$route.query.page' (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.fetchCurrentPage()
        }
      },
      '$route.query.q' (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.fetchCurrentPage()
        }
      }
    }
  }
</script>